export default function PageNotFound() {
  return <h1>Страница не найдена!</h1>
}

